module.exports = __webpack_public_path__ + "static/img/60pw.41531fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/60pw.jpg
// module id = vU+Y
// module chunks = 1